import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HolidayModel } from '../../../models/businessHoursModel';
import { HolidayDialogComponent } from './holiday-dialog.component';

@Injectable()
export class HolidayDialogService {

  constructor(private modalService: NgbModal) { }

  public getDialog(
    /*btnOkText: string = 'Create',
    btnCancelText: string = 'Cancel',*/
    holiday: HolidayModel,
    dialogSize: 'sm' | 'lg' = 'sm'): Promise<HolidayModel> {
    const modalRef = this.modalService.open(HolidayDialogComponent, { size: dialogSize, centered: true });
    modalRef.componentInstance.btnOkText = 'Save';
    modalRef.componentInstance.btnCancelText = 'Cancel';
    modalRef.componentInstance.holiday = { ...holiday };

    return modalRef.result;
  }
}
